import { CmsProtectionDetailsMultiRegistration } from '../../models/protection-details/cms-protection-details-multi-registration.interface';

export const mockCmsProtectionDetailsMultiRegistration: CmsProtectionDetailsMultiRegistration =
  {
    multiRegistrationApplianceListTitle: 'multiRegistrationApplianceListTitle',
  };
